import React, { useContext } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { calculateDailyResults } from "../utils/trainingResultsCalculations";
import { Box, Typography, useTheme } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { WorkoutContext } from "./provider/WorkoutProvider";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const BarChart = ({ monthlyTransactions }) => {
  const theme = useTheme();
  const dailyResults = calculateDailyResults(monthlyTransactions);
  const dateLabels = Object.keys(dailyResults).sort();
  const upperBodyData = dateLabels.map((day) => dailyResults[day].upperBody);
  const lowerBodyData = dateLabels.map((day) => dailyResults[day].lowerBody);
  const cardioData = dateLabels.map((day) => dailyResults[day].cardio);
  const { isLoadingWorkouts } = useContext(WorkoutContext);

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      // legend: {
      //   position: "top",
      // },
      title: {
        display: true,
        text: "日別スコア",
      },
    },
  };

  // calculateDailyResults;

  const labels = [
    "2026-06-03",
    "2026-06-04",
    "2026-06-05",
    "2026-06-06",
    "2026-06-07",
    "2026-06-08",
    "2026-06-09",
  ];

  const data = {
    labels: dateLabels,
    datasets: [
      {
        label: "上半身",
        data: upperBodyData,
        backgroundColor: theme.palette.upperBody.light,
      },
      {
        label: "下半身",
        data: lowerBodyData,
        backgroundColor: theme.palette.lowerBody.light,
      },
      {
        label: "有酸素運動",
        data: cardioData,
        backgroundColor: theme.palette.cardio.light,
      },
    ],
  };
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isLoadingWorkouts ? (
        <CircularProgress aria-label="Loading…" />
      ) : monthlyTransactions.length > 0 ? (
        <Bar options={options} data={data} />
      ) : (
        <Typography>データがありません</Typography>
      )}
    </Box>
  );
};

export default BarChart;
